module.exports = __webpack_public_path__ + "static/media/share_card_template_new.8711f34f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/share_card_template_new.png
// module id = 2151
// module chunks = 4